export default {
  pendingDiscount: false,
  discounts: []
};
